module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921072649_T.a2f05b63.jpg";